// Config.
import Config from './config/config.js';

// Misc dependencies.
import createActionTypes from '../../factories/actionTypes.js';

/**
 * <pre>
 * UgcWall module Action Types.
 *
 * Summary of responsibilities:
 *
 *  - defines Redux action types specific to component
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:UgcWall
 * @namespace
 *
 * @type {Object}
 * @property {String} REGISTER_INSTANCE Dispatched during app initialisation to register N instances of the given module (eg. we might have 3 different UgcWalls on one page).
 *
 * @property {String} RECEIVE_ITEMS Dispatched when a set of items are returned from the server.
 * @property {String} RECEIVE_ITEMS_ERROR Dispatched when an error occurs whilst retrieving items from the server.
 * @property {String} RECEIVE_CUSTOM_ITEMS Dispatched when a set of custom items are received from the api.
 * @property {String} PAGE_NEXT Dispatched when the user pages forward.
 * @property {String} PAGE_PREV Dispatched when the user pages backwards.
 * @property {String} PAGE_FIRST Dispatched when the user pages to the initial page.
 * @property {String} PAGE_LAST Dispatched when the user pages to the last page.
 * @property {String} UPDATE_PAGE_COUNT Dispatched when the total number of pages needs updating.
 * @property {String} SORT Dispatched when the user sorts the items.
 * @property {String} FILTER Dispatched when the user filters the items.
 * @property {String} VIEW_ITEM Dispatched when the user clicks to display a single item.
 * @property {String} CLOSE_ITEM Dispatched when we need to hide the item.
 * @property {String} SET_ACTIVE_STATE Dispatched when the current campaign state (page) changes.
 * @property {String} SET_COLLECTION_ID Dispatched when the collection id changes.
 * @property {String} SET_MAX_SCORE Dispatched when items are fetched.
 * @property {String} CLEAR_RETURN_FOCUS Distpatched when no overlay is opened and document receives click or TAB keydown
 */
const ActionTypes = {
  REGISTER_INSTANCE: 'REGISTER_INSTANCE',

  RECEIVE_ITEMS:        'RECEIVE_ITEMS',
  RECEIVE_ITEMS_ERROR:  'RECEIVE_ITEMS_ERROR',
  RECEIVE_CUSTOM_ITEMS: 'RECEIVE_CUSTOM_ITEMS',

  PAGE_NEXT:         'PAGE_NEXT',
  PAGE_PREV:         'PAGE_PREV',
  PAGE_FIRST:        'PAGE_FIRST',
  PAGE_LAST:         'PAGE_LAST',
  UPDATE_PAGE_COUNT: 'UPDATE_PAGE_COUNT',
  UPDATE_OFFSET:     'UPDATE_OFFSET',

  SORT:   'SORT',
  FILTER: 'FILTER',

  VIEW_ITEM:          'VIEW_ITEM',
  CLOSE_ITEM:         'CLOSE_ITEM',
  CLEAR_RETURN_FOCUS: 'CLEAR_RETURN_FOCUS',

  SET_ACTIVE_STATE:  'SET_ACTIVE_STATE',
  SET_COLLECTION_ID: 'SET_COLLECTION_ID',
  SET_POLLING:       'SET_POLLING',
  SET_SORTING:       'SET_SORTING',

  SET_USE_EXTERNAL_LINK_HANDLER: 'SET_USE_EXTERNAL_LINK_HANDLER',
  IS_FETCHING:                   'IS_FETCHING',
  HAS_FETCHED:                   'HAS_FETCHED',
};

export default createActionTypes(ActionTypes, Config.stateKey);
